import { AdminLinks } from '@app/modules/admin/routing/AdminLinks';
import { StreamerBoxLinks } from '@app/modules/streamer-box/routing/StreamerBoxLinks';
import { AuditLinks } from './audit/components/AuditLinks';
import { useIsComposeEnabled } from './compose/hooks/useIsComposeEnabled';
import { useIsContentAiEnabled } from './content-ai/hooks/useIsContentAiEnabled';
import { ContentAiLinks } from './content-ai/routing/ContentAiLinks';
import { ComposeLinks } from './compose/routing/ComposeLinks';
import { FragmentsLinks } from './fragments/routing/FragmentsLinks';
import { LoggerLinks } from './logger/LoggerLinks';
import { SearchLinks } from './search/routing/SearchLinks';

export function ModulesNavLinks() {
  return (
    <>
      <LoggerLinks />
      <FragmentsLinks />
      {useIsComposeEnabled() && <ComposeLinks />}
      <AuditLinks />
      <StreamerBoxLinks />
      <SearchLinks />
      {useIsContentAiEnabled() && <ContentAiLinks />}
      <AdminLinks />
    </>
  );
}
